import type { SimulatedParticipant } from "../../game-engine/types";
import styles from "./ParticipantAvatar.module.css";

interface ParticipantAvatarProps {
  participant: SimulatedParticipant;
  size?: "small" | "medium" | "large";
  answered?: boolean;
  showName?: boolean;
}

export function ParticipantAvatar({
  participant,
  size = "medium",
  answered = false,
  showName = true,
}: ParticipantAvatarProps) {
  return (
    <span
      className={styles.participant}
      role="group"
      data-size={size}
      data-tone={participant.tone}
      data-answered={answered ? "true" : undefined}
      aria-label={
        answered ? `${participant.name} har svarat` : participant.name
      }
    >
      <span
        className={styles.avatar}
        aria-hidden="true"
        style={participant.emoji ? { background: participant.color } : undefined}
      >
        {participant.emoji ?? participant.initials}
      </span>
      {showName ? (
        <span className={styles.name} aria-hidden="true">
          {participant.name}
        </span>
      ) : null}
    </span>
  );
}
